"use strict";

AOS.init()
// burger menu
const navSlide = () => {
    const burger = document.querySelector('.burger');
    const nav = document.querySelector('.nav-links');
    const navLinks = document.querySelectorAll('.nav-links li');

    burger.addEventListener('click', () => {
        nav.classList.toggle('nav-active');
        navLinks.forEach((link, index) => {
            if(link.style.animation){
                link.style.animation = ''
            } else{
                link.style.animation = `navLinkFade 0.5s ease forwards ${index / 7 + 1.5}s`;
            }
        });
        burger.classList.toggle('toggle');
    });
    
}

navSlide();

// Darkmode
var toggleButton = document.querySelector(".btn__dark");
toggleButton.addEventListener("click", toggleCallback);
var activeTheme = localStorage.getItem("theme");
if(activeTheme == "dark"){
    document.body.classList.add("dark");
    toggleButton.checked = true;
}
function toggleCallback(){
    if(document.body.classList.toggle("dark")){
        localStorage.setItem("theme", "dark");
    }else{
        localStorage.setItem("theme", "light");
    }
}

// date
var dateEl = new Date();
document.querySelector("#date")
.innerHTML = dateEl.getFullYear();

